export const CHANGE_LANG = 'CHANGE_LANG';
export const SHOW_DEVELOP = 'SHOW_DEVELOP';
export const SET_ALERT = 'SET_ALERT';
export const SHOW_LOADING = 'SHOW_LOADING';
export const SET_USER_MENUS = 'SET_USER_MENUS';
export const SET_FOOTER_MENUS = 'SET_FOOTER_MENUS';
export const SET_ALL_PAGES = 'SET_ALL_PAGES';
export const SET_COMPANY_INFO = 'SET_COMPANY_INFO';
// /content/:id хуудас cover image-тэй эсэх — Header overlay mode-д ашиглана
export const SET_PAGE_COVER = 'SET_PAGE_COVER';